import { _ as _toConsumableArray } from '../../unsorted/toConsumableArray.js';
import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { ClassNames } from '@emotion/react';
import { useMemo, useCallback } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { useHoverCardVideoPlay } from '../../hooks/useHoverCardVideoPlay.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { A as AspectRatioImage } from '../AspectRatioImage/AspectRatioImage.js';
import { i as isImageResizerProps } from '../../utils/imageHelpers2.js';
import { V as Video } from '../Video/Video.js';
import { B as ButtCon, a as Button } from '../ButtCon/ButtCon.js';
import { lineClamp } from '../../utils/sxChunks.js';
import { C as Caption } from '../Caption/Caption.js';
import { B as Body } from '../Body/Body.js';
import { b as baseFramedSx, f as framedLogoContainerSx, a as framedLogoSx, t as textContainerSx, c as buttonsContainerSx, d as baseContainerSx } from '../styles/styles.js';
import { F as FramedImage } from '../FramedImage/FramedImage.js';
import { useTheme } from '../../hooks/useTheme.js';
import { B as Box } from '../Box/Box.js';
import { L as Logo } from '../Logo/Logo2.js';
import { M as MenuItem } from '../index/index.js';
import { getHeadingTextStyles } from '../../utils/textStyleHelpers.js';
import { checkChildrenForClickables } from '../../utils/componentHelpers.js';
import { S as SmartClone } from '../SmartClone/SmartClone.js';
import { S as Stack } from '../Stack/Stack.js';
import { useForwardLocalDomRef } from '../../hooks/useForwardLocalDomRef.js';
import { useGetSubcomponentChild } from '../../hooks/useGetSubcompnentChild.js';
import { useGetSubcomponentChildren } from '../../hooks/useGetSubcomponentChildren.js';
import { useSplitApartChildrenAndSubComponents } from '../../hooks/useSplitApartChildrenAndSubComponents.js';
import { useResizeObserver } from '../../hooks/useResizeObserver.js';
import { i as isBaseClickable, a as isBox } from '../Chip/Chip.js';
import { B as BaseClickable } from '../BaseClickable/BaseClickable.js';

var _excluded$a = ["sx", "className", "use"],
  _excluded2$4 = ["responsiveSizes"];
function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardAssetImage(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    className = _ref.className,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var _ref2 = isImageResizerProps(use) ? props : _objectSpread$a(_objectSpread$a({}, props), {}, {
      responsiveSizes: undefined
    }),
    _ref2$responsiveSizes = _ref2.responsiveSizes,
    responsiveSizes = _ref2$responsiveSizes === void 0 ? [128, 256, 450, 512, 720, 860, 1024] : _ref2$responsiveSizes,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$4);
  var mergedSx = useMemo(function () {
    return merge({
      overflow: "hidden"
    }, sx);
  }, [sx]);
  return jsx(AspectRatioImage, _objectSpread$a(_objectSpread$a({}, otherProps), {}, {
    use: use,
    responsiveSizes: responsiveSizes,
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardAssetImage"),
    sx: mergedSx
  }));
}
CardAssetImage.displayName = "Card.AssetImage";

var _excluded$9 = ["className", "autoPlay", "controls", "playOnCardHover", "muted", "loop", "aspectRatio", "sx"];
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardAssetVideo(_ref) {
  var className = _ref.className,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? true : _ref$autoPlay,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? false : _ref$controls,
    _ref$playOnCardHover = _ref.playOnCardHover,
    playOnCardHover = _ref$playOnCardHover === void 0 ? false : _ref$playOnCardHover,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? autoPlay : _ref$muted,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded$9);
  var mergedSx = useMemo(function () {
    return merge({
      w: "100%",
      objectFit: "cover",
      objectPosition: "center",
      aspectRatio: aspectRatio
    }, sx);
  }, [aspectRatio, sx]);
  return jsx(Video, _objectSpread$9(_objectSpread$9({}, props), {}, {
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardAssetVideo"),
    autoPlay: playOnCardHover ? false : autoPlay,
    controls: controls,
    muted: muted,
    loop: loop,
    sx: mergedSx
  }));
}
CardAssetVideo.displayName = "Card.AssetVideo";

var _excluded$8 = ["variant", "size", "className"],
  _excluded2$3 = ["onClick"];
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardButtCon(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "tertiary" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var _ref2 = "onClick" in props ? props : _objectSpread$8(_objectSpread$8({}, props), {}, {
      onClick: null
    }),
    onClick = _ref2.onClick,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$3);
  var handleOnClick = useCallback(function (ev) {
    ev.stopPropagation();
    if (typeof onClick === "function") {
      onClick(ev);
    }
  }, [onClick]);
  return jsx(ButtCon, _objectSpread$8(_objectSpread$8(_objectSpread$8({}, otherProps), onClick ? {
    onClick: handleOnClick
  } : {}), {}, {
    size: size,
    variant: variant,
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardButtCon")
  }));
}
CardButtCon.displayName = "Card.ButtCon";
CardButtCon.SvgIcon = ButtCon.SvgIcon;

var _excluded$7 = ["sx", "variant", "className"],
  _excluded2$2 = ["onClick"];
function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardButton(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "tertiary" : _ref$variant,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var _ref2 = "onClick" in props ? props : _objectSpread$7(_objectSpread$7({}, props), {}, {
      onClick: null
    }),
    onClick = _ref2.onClick,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$2);
  var handleOnClick = useCallback(function (ev) {
    ev.stopPropagation();
    if (typeof onClick === "function") {
      onClick(ev);
    }
  }, [onClick]);
  return jsx(Button, _objectSpread$7(_objectSpread$7(_objectSpread$7({}, otherProps), onClick ? {
    onClick: handleOnClick
  } : {}), {}, {
    variant: variant,
    sx: merge({
      flexGrow: 1
    }, sx),
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardButton")
  }));
}
CardButton.displayName = "Card.Button";
CardButton.Icon = Button.Icon;
CardButton.Logo = Button.Logo;

var _excluded$6 = ["size", "weight", "sx", "rc", "className"];
function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardCaption(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "bold" : _ref$weight,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$6);
  return jsx(Caption, _objectSpread$6(_objectSpread$6({}, props), {}, {
    sx: merge(_objectSpread$6({
      textAlign: "left"
    }, lineClamp(1)), sx),
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardCaption"),
    size: size,
    weight: weight,
    rc: rc
  }));
}
CardCaption.displayName = "Card.Caption";

var _excluded$5 = ["size", "weight", "sx", "rc", "className"];
function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardDescription(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? "regular" : _ref$weight,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$5);
  return jsx(Body, _objectSpread$5(_objectSpread$5({}, props), {}, {
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardDescription"),
    sx: merge({
      color: "base.color.text.body.secondary",
      textAlign: "left"
    }, sx),
    size: size,
    weight: weight,
    rc: rc
  }));
}
CardDescription.displayName = "Card.Description";

var _excluded$4 = ["sx", "className", "circularFrame", "use"],
  _excluded2$1 = ["responsiveSizes"];
function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardFramedImage(_ref) {
  var _otherProps$relativeI;
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    className = _ref.className,
    _ref$circularFrame = _ref.circularFrame,
    circularFrame = _ref$circularFrame === void 0 ? false : _ref$circularFrame,
    use = _ref.use,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var _useTheme = useTheme(),
    base = _useTheme.base;
  var _ref2 = isImageResizerProps(use) ? props : _objectSpread$4(_objectSpread$4({}, props), {}, {
      responsiveSizes: undefined
    }),
    _ref2$responsiveSizes = _ref2.responsiveSizes,
    responsiveSizes = _ref2$responsiveSizes === void 0 ? [32, 64, 128, 256] : _ref2$responsiveSizes,
    otherProps = _objectWithoutProperties(_ref2, _excluded2$1);
  var mergedSx = useMemo(function () {
    return merge(baseFramedSx, sx);
  }, [sx]);
  return jsx(FramedImage, _objectSpread$4(_objectSpread$4({}, otherProps), {}, {
    use: use,
    responsiveSizes: responsiveSizes,
    circularFrame: circularFrame,
    sx: mergedSx,
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardFramedImage"),
    relativeImageSizeInLayout: (_otherProps$relativeI = otherProps.relativeImageSizeInLayout) !== null && _otherProps$relativeI !== void 0 ? _otherProps$relativeI : base.icon.size[500]
  }));
}
CardFramedImage.displayName = "Card.FramedImage";

var _excluded$3 = ["logo", "sx", "testId", "className", "circularFrame"];
function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardFramedLogo(_ref) {
  var logo = _ref.logo,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    testId = _ref.testId,
    className = _ref.className,
    _ref$circularFrame = _ref.circularFrame,
    circularFrame = _ref$circularFrame === void 0 ? false : _ref$circularFrame,
    props = _objectWithoutProperties(_ref, _excluded$3);
  var mergedSx = useMemo(function () {
    return merge(framedLogoContainerSx, {
      bgc: "base.color.fixed.black.1000",
      brad: circularFrame ? "50%" : "base.borderRadius.x2"
    }, sx);
  }, [sx, circularFrame]);
  return jsx(Box, _objectSpread$3(_objectSpread$3({}, props), {}, {
    testId: testId,
    sx: mergedSx,
    rc: jsx("span", {}),
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardFramedLogo"),
    children: jsx(Logo, {
      logo: logo,
      sx: framedLogoSx
    })
  }));
}
CardFramedLogo.displayName = "Card.FramedLogo";

var _excluded$2 = ["sx", "children", "size", "domRef", "className"];
function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardMenuItem(_ref) {
  var _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    size = _ref.size,
    domRef = _ref.domRef,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx(MenuItem, _objectSpread$2(_objectSpread$2({}, props), {}, {
    size: size,
    domRef: domRef,
    sx: merge({
      px: "base.spacing.x5",
      bradbl: "0px",
      bradbr: "0px"
    }, sx),
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardMenuItem"),
    children: children
  }));
}
CardMenuItem.displayName = "Card.MenuItem";
CardMenuItem.Label = MenuItem.Label;
CardMenuItem.Icon = MenuItem.Icon;
CardMenuItem.Caption = MenuItem.Caption;
CardMenuItem.FramedIcon = MenuItem.FramedIcon;
CardMenuItem.FramedLogo = MenuItem.FramedLogo;
CardMenuItem.FramedImage = MenuItem.FramedImage;
CardMenuItem.IntentIcon = MenuItem.IntentIcon;
CardMenuItem.PriceDisplay = MenuItem.PriceDisplay;
CardMenuItem.Badge = MenuItem.Badge;
CardMenuItem.OverflowPopoverMenu = MenuItem.OverflowPopoverMenu;
CardMenuItem.OverflowDrawerMenu = MenuItem.OverflowDrawerMenu;
CardMenuItem.StatefulButtCon = MenuItem.StatefulButtCon;
CardMenuItem.SwapStack = MenuItem.SwapStack;
CardMenuItem.FramedStack = MenuItem.FramedStack;
CardMenuItem.Avatar = MenuItem.Avatar;

var _excluded$1 = ["children", "sx", "rc", "className"];
function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CardTitle(_ref) {
  var children = _ref.children,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    _ref$rc = _ref.rc,
    rc = _ref$rc === void 0 ? jsx("span", {}) : _ref$rc,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var theme = useTheme();
  var titleStyles = merge(_objectSpread$1({
    textAlign: "left",
    color: "base.color.text.heading.primary",
    flexShrink: 0
  }, lineClamp(2)), getHeadingTextStyles({
    themeProps: theme,
    size: "xSmall",
    weight: "bold"
  }), sx);
  return jsx(Box, _objectSpread$1(_objectSpread$1({}, props), {}, {
    sx: titleStyles,
    rc: rc,
    className: "".concat(className !== null && className !== void 0 ? className : "", " CardTitle"),
    children: children
  }));
}
CardTitle.displayName = "Card.Title";

var _excluded = ["className", "testId", "rc", "sx", "children", "elevation", "selected"],
  _excluded2 = ["onClick"],
  _excluded3 = ["domRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Card(_ref) {
  var _ref4, _ref5, _theme$components2;
  var className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "Card" : _ref$testId,
    rc = _ref.rc,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    children = _ref.children,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 1 : _ref$elevation,
    selected = _ref.selected,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _ref2 = "onClick" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      onClick: null
    }),
    onClick = _ref2.onClick,
    propsMinusOnClick = _objectWithoutProperties(_ref2, _excluded2);
  var _ref3 = "domRef" in propsMinusOnClick ? propsMinusOnClick : _objectSpread(_objectSpread({}, propsMinusOnClick), {}, {
      domRef: null
    }),
    domRef = _ref3.domRef,
    propsMinusOnClickAndDomRef = _objectWithoutProperties(_ref3, _excluded3);
  var localDomRef = useForwardLocalDomRef(domRef);
  var baseClickableProps = _objectSpread(_objectSpread({
    onClick: onClick,
    domRef: localDomRef
  }, rc ? {
    rc: rc
  } : {}), propsMinusOnClickAndDomRef);
  var menuItem = useGetSubcomponentChild(children, CardMenuItem);
  var assetImage = useGetSubcomponentChild(children, CardAssetImage);
  var assetVideo = useGetSubcomponentChild(children, CardAssetVideo);
  var title = useGetSubcomponentChild(children, CardTitle);
  var description = useGetSubcomponentChild(children, CardDescription);
  var caption = useGetSubcomponentChild(children, CardCaption);
  var framedLogo = useGetSubcomponentChild(children, CardFramedLogo);
  var framedImage = useGetSubcomponentChild(children, CardFramedImage);
  var buttons = useGetSubcomponentChildren(children, CardButton);
  var buttCons = useGetSubcomponentChildren(children, CardButtCon);
  var _useSplitApartChildre = useSplitApartChildrenAndSubComponents(children, [CardAssetImage, CardAssetVideo, CardTitle, CardCaption, CardFramedLogo, CardFramedImage, CardMenuItem, CardDescription, CardButtCon, CardButton]),
    otherChildren = _useSplitApartChildre.otherChildren;
  var hasButtons = useMemo(function () {
    return Boolean(buttons === null || buttons === void 0 ? void 0 : buttons.length) || Boolean(buttCons === null || buttCons === void 0 ? void 0 : buttCons.length) || Boolean(menuItem) || checkChildrenForClickables(otherChildren);
  }, [buttons, buttCons, menuItem, otherChildren]);
  var containsClickables = hasButtons || Boolean(menuItem);
  var assetMediaToUse = assetVideo !== null && assetVideo !== void 0 ? assetVideo : assetImage;
  var framedMediaToUse = framedLogo !== null && framedLogo !== void 0 ? framedLogo : framedImage;
  var localAssetMediaRef = useForwardLocalDomRef((_ref4 = assetMediaToUse === null || assetMediaToUse === void 0 ? void 0 : assetMediaToUse.props.domRef) !== null && _ref4 !== void 0 ? _ref4 : {
    current: null
  });
  var _useResizeObserver = useResizeObserver(localAssetMediaRef),
    assetMediaHeight = _useResizeObserver.height;
  var innerContents = jsxs(Fragment, {
    children: [menuItem && menuItem, assetMediaToUse && jsx(SmartClone, {
      domRef: localAssetMediaRef,
      children: assetMediaToUse
    }), jsxs(Box, {
      sx: textContainerSx,
      rc: jsx("span", {}),
      className: "textContainer",
      testId: "".concat(testId, "__textContainer"),
      children: [framedMediaToUse, ((_ref5 = title !== null && title !== void 0 ? title : caption) !== null && _ref5 !== void 0 ? _ref5 : description) ? jsxs(Stack, {
        rc: jsx("span", {}),
        sx: {
          pt: "base.spacing.x2",
          minh: "90px"
        },
        gap: "base.spacing.x1",
        className: "innerTextContainer",
        children: [caption, title, description]
      }) : null]
    }), hasButtons && jsxs(Box, {
      rc: jsx("span", {}),
      sx: buttonsContainerSx,
      className: "buttonsContainer",
      testId: "".concat(testId, "__buttonsRow"),
      children: [buttCons, buttons]
    }), otherChildren]
  });
  var mergedContainerSx = useMemo(function () {
    var _theme$components$Car, _theme$components;
    return merge(baseContainerSx, {
      "--cardAssetMediaHeight": "".concat(assetMediaHeight !== null && assetMediaHeight !== void 0 ? assetMediaHeight : 0, "px")
    }, (_theme$components$Car = (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components.Card) === null || _theme$components === void 0 ? void 0 : _theme$components.sxOverride) !== null && _theme$components$Car !== void 0 ? _theme$components$Car : {}, sx);
  }, [sx, (_theme$components2 = theme.components) === null || _theme$components2 === void 0 || (_theme$components2 = _theme$components2.Card) === null || _theme$components2 === void 0 ? void 0 : _theme$components2.sxOverride, assetMediaHeight]);
  var baseClassNames = useMemo(function () {
    return [className, "Card", "Card--elevation".concat(elevation), {
      "Card--selected": selected
    }];
  }, [className, selected, elevation]);

  // @NOTE: setup the playOnCardHover functionality, if neccissary
  useHoverCardVideoPlay(localDomRef, assetVideo, localAssetMediaRef);
  return jsx(ClassNames, {
    children: function children(_ref6) {
      var cx = _ref6.cx;
      return isBaseClickable(onClick, rc, containsClickables) ? jsx(BaseClickable, _objectSpread(_objectSpread({}, baseClickableProps), {}, {
        testId: testId,
        sx: mergedContainerSx,
        className: cx.apply(void 0, _toConsumableArray(baseClassNames).concat(["Card--isClickable", "Card--BaseClickable"])),
        children: innerContents
      })) : isBox(onClick, rc, containsClickables) ? jsx(Box, _objectSpread(_objectSpread({}, propsMinusOnClickAndDomRef), {}, {
        onClick: onClick,
        domRef: localDomRef,
        rc: rc,
        testId: testId,
        sx: mergedContainerSx,
        className: cx.apply(void 0, _toConsumableArray(baseClassNames).concat(["Card--Box", {
          "Card--isClickable": Boolean(onClick)
        }])),
        children: innerContents
      })) : null;
    }
  });
}
Card.displayName = "Card";
Card.Title = CardTitle;
Card.Caption = CardCaption;
Card.Description = CardDescription;
Card.FramedLogo = CardFramedLogo;
Card.FramedImage = CardFramedImage;
Card.AssetImage = CardAssetImage;
Card.MenuItem = CardMenuItem;
Card.Button = CardButton;
Card.ButtCon = CardButtCon;
Card.AssetVideo = CardAssetVideo;

export { Card as C };
//# sourceMappingURL=Card.js.map
